import { render, staticRenderFns } from "./PromotionPacks.vue?vue&type=template&id=6515c299&scoped=true&"
import script from "./PromotionPacks.vue?vue&type=script&lang=js&"
export * from "./PromotionPacks.vue?vue&type=script&lang=js&"
import style0 from "./PromotionPacks.vue?vue&type=style&index=0&id=6515c299&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6515c299",
  null
  
)

export default component.exports